import type { SchemaBuilderFieldIconProps } from "./schema-builder-field-icon.type";

import {
  FieldStringOutlined,
  FieldNumberOutlined,
  AlignLeftOutlined,
  DownOutlined,
  DownSquareOutlined,
  CheckSquareOutlined,
  InfoCircleOutlined,
  PartitionOutlined,
  LockOutlined,
  DiffOutlined,
} from "@ant-design/icons";

import { isSchemaFieldNumber, isSchemaFieldText } from "@/entities/schema";

export const SchemaBuilderFieldIcon = ({
  schema,
}: SchemaBuilderFieldIconProps) => {
  const { type } = schema;

  if (isSchemaFieldNumber(schema)) return <FieldNumberOutlined />;

  if (isSchemaFieldText(schema)) return <FieldStringOutlined />;

  if (type === "label") return <InfoCircleOutlined />;

  if (type === "textArea") return <AlignLeftOutlined />;

  if (type === "checkbox") return <CheckSquareOutlined />;

  if (type === "select") return <DownOutlined />;

  if (type === "assetUnlockToggler") return <LockOutlined />;

  if (type === "expression") return <DiffOutlined />;

  if (type === "inspectedComponent") return <PartitionOutlined />;

  if (type === "materials" || type === "defects" || type === "severities")
    return <DownSquareOutlined />;

  return null;
};
